/* ============================================================
   ONE CLICK UPSELL JS — Karar Store
   Uses Rs.400 Bundle Offer variant for correct checkout price
   ============================================================ */

(function () {
  'use strict';

  var UPSELL_RULES = [
    {
      triggerHandle: 'pu-leather-wallet-for-men-pop-up-card-holder',
      upsell: {
        title: 'Pure Leather Keychain',
        description: 'Full-grain leather. Matches your wallet perfectly. Customisable with your name.',
        image: 'https://cdn.shopify.com/s/files/1/0626/1912/3870/products/Black.png',
        originalPrice: 500,
        discountedPrice: 400,
        saving: 100,
        // Using the dedicated Bundle Offer variant at Rs.400
        variants: [
          { id: 47838454579358, title: 'Black', inStock: true },
          { id: 47838454612126, title: 'Brown', inStock: false }
        ]
      }
    }
  ];

  function getCurrentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    return match ? match[1] : null;
  }

  function fmt(amount) {
    return 'Rs. ' + Math.round(amount).toLocaleString();
  }

  function buildModal(rule, variantId, quantity) {
    var existing = document.querySelector('.cro-upsell-overlay');
    if (existing) existing.remove();

    var u = rule.upsell;
    var selectedVariantId = u.variants.find(function(v) { return v.inStock; }).id;
    var pendingItems = [{ id: variantId, quantity: quantity }];

    var overlay = document.createElement('div');
    overlay.className = 'cro-upsell-overlay';
    overlay.innerHTML =
      '<div class="cro-upsell-modal" role="dialog" aria-modal="true">' +
        '<button class="cro-upsell__close" aria-label="Close">&times;</button>' +
        '<div class="cro-upsell__eyebrow">🎁 Special One-Time Offer</div>' +
        '<div class="cro-upsell__heading">Add a matching keychain for just ' + fmt(u.discountedPrice) + '?</div>' +
        '<div class="cro-upsell__product">' +
          '<img src="' + u.image + '" alt="' + u.title + '" loading="lazy">' +
          '<div class="cro-upsell__product-info">' +
            '<div class="cro-upsell__product-title">' + u.title + '</div>' +
            '<div class="cro-upsell__product-desc">' + u.description + '</div>' +
            '<div class="cro-upsell__price-row">' +
              '<span class="cro-upsell__price-orig">' + fmt(u.originalPrice) + '</span>' +
              '<span class="cro-upsell__price-disc">' + fmt(u.discountedPrice) + '</span>' +
              '<span class="cro-upsell__price-badge">Save ' + fmt(u.saving) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="cro-upsell__variants">' +
          u.variants.map(function(v) {
            return '<button class="cro-upsell__variant-btn' + (v.inStock && v.id === selectedVariantId ? ' is-active' : '') + '" ' +
              'data-variant-id="' + v.id + '" ' +
              (v.inStock ? '' : 'disabled style="opacity:0.4;cursor:not-allowed"') + '>' +
              v.title + (v.inStock ? '' : ' (Sold Out)') +
            '</button>';
          }).join('') +
        '</div>' +
        '<button class="cro-upsell__accept" id="cro-upsell-accept">✅ Yes! Add Keychain for ' + fmt(u.discountedPrice) + '</button>' +
        '<button class="cro-upsell__decline" id="cro-upsell-decline">No thanks, continue without it</button>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.querySelectorAll('.cro-upsell__variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        overlay.querySelectorAll('.cro-upsell__variant-btn').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selectedVariantId = parseInt(btn.dataset.variantId);
      });
    });

    function closeModal() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.remove(); }, 350);
    }

    function proceedToCart(items) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function() { window.location.href = '/cart'; })
      .catch(function() { window.location.href = '/cart'; });
    }

    document.getElementById('cro-upsell-accept').addEventListener('click', function() {
      this.textContent = 'Adding...';
      this.disabled = true;
      proceedToCart(pendingItems.concat([{ id: selectedVariantId, quantity: 1 }]));
    });

    document.getElementById('cro-upsell-decline').addEventListener('click', function() {
      closeModal();
      proceedToCart(pendingItems);
    });

    overlay.querySelector('.cro-upsell__close').addEventListener('click', function() {
      closeModal();
      proceedToCart(pendingItems);
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) { closeModal(); proceedToCart(pendingItems); }
    });

    requestAnimationFrame(function() {
      requestAnimationFrame(function() { overlay.classList.add('is-open'); });
    });
  }

  function interceptATC(rule) {
    var productForm = document.querySelector('product-form');
    if (!productForm || productForm.dataset.upsellBound) return;
    productForm.dataset.upsellBound = '1';

    productForm.addEventListener('click', function(e) {
      var btn = e.target.closest('[name="add"], .product-form__submit, button[type="submit"]');
      if (!btn) return;
      if (btn.disabled) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var form = productForm.querySelector('form');
      var variantInput = form ? form.querySelector('[name="id"]') : null;
      var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      var variantId = variantInput ? parseInt(variantInput.value) : null;
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) return;
      buildModal(rule, variantId, quantity);
    }, true);
  }

  function init() {
    var handle = getCurrentHandle();
    if (!handle) return;
    var rule = UPSELL_RULES.find(function(r) { return r.triggerHandle === handle; });
    if (!rule) return;

    var tries = 0;
    var interval = setInterval(function() {
      var productForm = document.querySelector('product-form');
      if (productForm || tries > 30) {
        clearInterval(interval);
        if (productForm) interceptATC(rule);
      }
      tries++;
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
